import React from 'react'

export default function AccountButton() {

    return (
        <button className='button success'>Account</button>
    )
}
